<template>
  <Modal v-model="showMoal" width="1000">
    <p slot="header" class="text-center">租赁记录</p>
    <Table stripe size="small" :data="tableData" :columns="tableColumns" :loading="tableLoading"></Table>
  </Modal>
</template>

<script>
import { listContractInfos } from '@/api/invest/contract'
import { formatScContractStatus } from '@/utils/tagStatus'

export default {
  data () {
    return {
      showMoal: false,
      tableLoading: false,
      curDeviceInfo: {},
      tableData: [],
      tableColumns: [
        { title: '合同编号', key: 'code' },
        { title: '合同名称', key: 'name' },
        { title: '租户名称', tooltip: true, ellipsis: true, minWidth: 100, key: 'advertiserName' },
        {
          title: '租赁周期',
          align: 'center',
          minWidth: 140,
          key: 'startDate',
          render: (h, { row }) => {
            return h('span', `${row.startDate} 至 ${row.endDate}`)
          }
        },
        { title: '创建时间', align: 'center', minWidth: 120, key: 'createTime' },
        { title: '创建人', align: 'center', key: 'createUserName' },
        {
          title: '合同状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return formatScContractStatus(
              h,
              params.row.status,
              params.row.contractStatusName
            )
          }
        }
      ]
    }
  },
  methods: {
    showModal (params) {
      this.curDeviceInfo = params
      this.getRecordsList()
      this.showMoal = true
    },
    getRecordsList () {
      listContractInfos({ resourceId: this.curDeviceInfo.id }).then(res => {
        if (res && !res.errcode) {
          this.tableData = res
        } else {
          this.tableData = []
        }
      })
    }
  }
}
</script>
